<style>
.app-search input::placeholder {
  color: #a6b0cf !important;
}
.app-search input {
  color: white !important;
  min-width: 25rem;
}
</style>

<script>
import { mapGetters } from 'vuex'
import {get_acsrf_token, with_acrf_token} from "@/methods";
import store from "@/state/store";

/**
 * Nav-bar Component
 */
export default {
  computed: {
    ...mapGetters([
        'getPersonaName',
        'getPersonaAvatar',
        'getServer',
        'getServers',
        'getSubscriberStatus'
    ])
  },
  components: { },
  created() {
    this.getNotificationCount();
    if((!this.getSubscriberStatus() && !this.getServers().length)) {
      this.redactFeatures = true;
    } else {
      this.redactFeatures = false;
    }
  },
  sockets: {
    notification(data) {
      if(!data || data === null || data === {}) return this.getNotificationCount();
      let watcherEvents = ['user.join','user.leave','user.kicked','user.vac','user.battleye'];
      if(watcherEvents.includes(data.event)) this.handleWatcherEvent(data);
    }
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    async markNotificationAsRead(notification_id) {
      with_acrf_token().then((r) => {
        let payload = {
          acsrf_token: r.acsrf_token,
          notification_id: notification_id
        };
        fetch(process.env.VUE_APP_ROOT_API + 'v1/notifications/read', {
          method: 'POST',
          body: JSON.stringify(payload),
          credentials: 'include'
        })
          .then(response => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error(`(${this.$vnode.componentOptions.tag}) Failed with API error ${response.status}=${response.statusText} (${response.url})`);
            }
          })
          .then(data => {

          })
          .catch(error => {

          });
      });
    },
    getNotificationCount() {
      fetch(process.env.VUE_APP_ROOT_API + 'v1/notifications/badge', {credentials: 'include'})
        .then(response => {
          if(response.ok){
            return response.json();
          } else {
            throw new Error(`(${this.$vnode.componentOptions.tag}) Failed with API error ${response.status}=${response.statusText} (${response.url})`);
          }
        })
        .then(data => {
          this.notificationCount = data.count;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  data() {
    return {
      redactFeatures: true,
      notificationCount: 0,
      notificationsEnabled: false
    };
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-light.svg" alt height="24" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/cfcloud.svg" alt width="110" />
            </span>
          </router-link>
        </div>

        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
        >
          <i class="far fa-bars"></i>
        </button>
      </div>


      <div class="d-flex">
        <div class="dropdown d-inline-block" v-if="notificationsEnabled">
          <button
              type="button"
              class="btn header-item noti-icon right-bar-toggle toggle-right"
              @click="toggleRightSidebar"
          >
            <i class="fad fa-bell toggle-right"></i>
            <template v-if="notificationCount > 0">
              <span class="badge badge-danger badge-pill">
                {{ notificationCount }}
              </span>
            </template>
          </button>
        </div>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <img
                id="app-avatar"
                class="rounded-circle header-profile-user"
                :src="getPersonaAvatar()"
                alt="User profile picture"
            />
            <span class="d-none d-xl-inline-block ml-1">{{ getPersonaName() }}</span>
          </template>

          <router-link to="/logout" class="dropdown-item text-danger">
            <i class="fad fa-sign-out font-size-16 align-middle mr-1 text-danger"></i>
            {{ $t('navbar.logout') }}
          </router-link>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
